let bThirdPartyLoaded = false;

function initThirdParty(config, GenesysJS) {
  const $$ = GenesysJS.data;

  if (!bThirdPartyLoaded) {
    bThirdPartyLoaded = true;
    GenesysJS.log('Loading ThirdPartyHelper plugin.');

    GenesysJS.subscribe('ThirdPartyHelper.ready', () => {
      GenesysJS.command('ThirdPartyHelper.open', config);
    });
  } else { /**If the third-party iframe is already loaded, look for the iFrame existence, if yes, configure messenger again with the config*/
    const iFrameLoaded = $$('ThirdPartyHelper.iFrameLoaded');

    if (iFrameLoaded) {
      GenesysJS.command('ThirdPartyHelper.update', config.deploymentConfig);
    } else GenesysJS.command('ThirdPartyHelper.open', config.deploymentConfig);
  }
}

export default initThirdParty;
